import { render, staticRenderFns } from "./pmequimentrepairinfo-detail.vue?vue&type=template&id=00b6e17a&scoped=true"
import script from "./pmequimentrepairinfo-detail.vue?vue&type=script&lang=js"
export * from "./pmequimentrepairinfo-detail.vue?vue&type=script&lang=js"
import style0 from "./pmequimentrepairinfo-detail.vue?vue&type=style&index=0&id=00b6e17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6e17a",
  null
  
)

export default component.exports